import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  WidthMode,
} from "../services/types/ComponentTypes";

/**
 * Leave approve/reject screen fallback config.
 */
export const screen_2299_leave_approve_drawer: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Leave Approval",
    visibility: [1],
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "leave_approve_reject",
        TableName: "employee_leave",
        DisplayName: "Leave Approval",
        columnNumber: "1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        childComponents: [
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "drp_approval_action",
            label: "Action",
            placeholder: "Select option",
            required: true,
            BindValue: "drp_approval_action",
            Json_Attribute: "status",
            options: [
              { value: "approve", label: "Approve" },
              { value: "reject", label: "Reject" },
            ],
          } as any,
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_employee_name",
            label: "Employee Name",
            required: false,
            isReadOnly: true,
            BindValue: "txt_employee_name",
            Json_Attribute: "employee_name",
          } as any,
          {
            componentType: ComponentType.DATE_FIELD,
            name: "date_start",
            label: "From Date",
            required: false,
            isReadOnly: true,
            BindValue: "date_start",
            Json_Attribute: "start_date",
          } as any,
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_total_days",
            label: "No of Days",
            required: false,
            isReadOnly: true,
            BindValue: "txt_total_days",
            Json_Attribute: "total_days",
          } as any,
          {
            componentType: ComponentType.DATE_FIELD,
            name: "date_end",
            label: "To Date",
            required: false,
            isReadOnly: true,
            BindValue: "date_end",
            Json_Attribute: "end_date",
          } as any,
          {
            componentType: ComponentType.TEXT_AREA,
            name: "txt_remarks",
            label: "Remarks",
            placeholder: "Required when rejecting leave",
            required: false,
            rows: 3,
            BindValue: "txt_remarks",
            Json_Attribute: "rejection_reason",
          } as any,
          {
            componentType: ComponentType.TEXT_AREA,
            name: "txt_reason",
            label: "Reason",
            required: false,
            rows: 4,
            isReadOnly: true,
            BindValue: "txt_reason",
            Json_Attribute: "reason",
          } as any,
        ],
      } as unknown as ComponentConfig,
      {
        componentType: LayoutTypes.GROUP,
        style: {
          direction: FlexDirection.ROW,
          justifyContent: "space-between",
          padding: 10,
        },
        childComponents: [
          {
            componentType: ComponentType.BUTTON,
            name: "Back",
            onPressAction: "navigate_2201",
            style: {
              widthMode: WidthMode.WRAP,
            },
          } as any,
          {
            componentType: ComponentType.BUTTON,
            name: "Submit",
            onPressAction: "submit_leave_approval",
            style: {
              backgroundColor: "var(--primary-green)",
              widthMode: WidthMode.WRAP,
            },
          } as any,
        ],
      },
    ],
  },
];
